import { ColumnsType } from 'antd/lib/table';
import { InvoiceDto } from 'common/dto/generated/InvoiceDto';
import { InvoiceFilteredColumns } from './InvoiceColumns';

export const InvoiceAcceptedColumns: ColumnsType<InvoiceDto> = [
  InvoiceFilteredColumns.isPaper,
  { ...InvoiceFilteredColumns.expiresAt, fixed: 'left' },
  InvoiceFilteredColumns.state,
  InvoiceFilteredColumns.supplierName,
  InvoiceFilteredColumns.supplierFiscal,
  InvoiceFilteredColumns.protocol,
  InvoiceFilteredColumns.issuedDate,
  InvoiceFilteredColumns.issuedNumber,
  InvoiceFilteredColumns.invoiceTypeCode,
  InvoiceFilteredColumns.totalAmount
];
